import { Fragment } from "react";
import { NavLink } from "react-router-dom";

import { classNames } from "~/utils/utils";
import ExternalLink from "~/components/ExternalLink";
import type { ITemplateUser } from "~/interfaces";
import { userStore } from "~/stores/user";
import { ROUTES, CONSUMPTION_KEY } from "~/const";
import { getLinks } from "~/providers/route";
import { useTrans } from "~/hooks/useTrans";
import BackToProjects from "~/components/BackToProjects";

import "./style.less";

export default function Links({
	projectId = 0,
	keyId = 0,
	checkInternalRole = "none",
}: ITemplateUser) {
	const { trans }= useTrans();
	const { userData } = userStore(userState => ({
		userData: userState.user,
	}));

	function getClassName({ isActive }, url: string): string {
		const myProjects = `/${ROUTES.MY_PROJECTS.path}`;
		const path = location.pathname;

		return classNames([
			"links__item",
			...isActive
				|| (url.indexOf(myProjects) !== -1 && path.match(ROUTES.WALLET_INVITATION.test))
				|| (url.indexOf(myProjects) !== -1 && path.match(ROUTES.PROJECT_INVITATION.test))
				|| (url.indexOf(CONSUMPTION_KEY) !== -1 && path.indexOf(CONSUMPTION_KEY) !== -1)
				? ["active"]
				: [],
		]);
	}

	return <ul className="links">
		{ projectId > 0 && keyId === 0 && <BackToProjects projectId={projectId} checkInternalRole={checkInternalRole} /> }
		{ getLinks(trans, userData, projectId, keyId, checkInternalRole).map(item => <Fragment key={item.url}>
			{ item.type === "external" && <ExternalLink to={item.url} key={item.url} className="links__item">
				<span className="links__itemIcon">{ item.icon }</span>
				<span className="links__itemText">{ item.text }</span>
				<span className="links__itemOpts">{ item.opts }</span>
			</ExternalLink> }
			{ item.type === "link" && <NavLink to={item.url} key={item.url} className={data => getClassName(data, item.url)}>
				<span className="links__itemIcon">{ item.icon }</span>
				<span className="links__itemText">{ item.text }</span>
				<span className="links__itemOpts">{ item.opts }</span>
			</NavLink> }
			{ item.type === "separator" && <li style={{ margin: "var(--margin-small) 12px", height: "1px", background: "var(--dark-green-text-color)" }}></li> }
		</Fragment>) }
	</ul>;
}
